import React from 'react';
import Button from '../../../components/ui/Button';

const ClockActionButtons = ({ 
  onClockIn, 
  onClockOut, 
  disabled = false,
  isProcessing = false,
  lastAction = null,
  employeeCode = '',
  compact = false
}) => {
  const canClockIn = employeeCode?.length >= 4 && !disabled;
  const canClockOut = employeeCode?.length >= 4 && !disabled;

  return (
    <div className={`flex flex-col ${compact ? 'gap-3' : 'gap-4'} max-w-xs`}>
      <Button
        variant="default"
        size={compact ? 'lg' : 'xl'}
        fullWidth
        onClick={onClockIn}
        disabled={!canClockIn || isProcessing}
        loading={isProcessing && lastAction === 'clock-in'}
        iconName="LogIn"
        iconPosition="left"
        className={`${compact ? 'h-16 text-lg' : 'h-20 text-xl'} font-semibold bg-success hover:bg-success/90 text-success-foreground touch-feedback elevation-1 hover:elevation-2 transition-all duration-200`}
      >
        {isProcessing && lastAction === 'clock-in' ? 'Einstempeln...' : 'Einstempeln'}
      </Button>
      
      <Button
        variant="destructive"
        size={compact ? 'lg' : 'xl'}
        fullWidth
        onClick={onClockOut}
        disabled={!canClockOut || isProcessing}
        loading={isProcessing && lastAction === 'clock-out'}
        iconName="LogOut"
        iconPosition="left"
        className={`${compact ? 'h-16 text-lg' : 'h-20 text-xl'} font-semibold touch-feedback elevation-1 hover:elevation-2 transition-all duration-200`}
      >
        {isProcessing && lastAction === 'clock-out' ? 'Ausstempeln...' : 'Ausstempeln'}
      </Button>
    </div>
  );
};

export default ClockActionButtons;